import React from 'react';
import GroupDetailContent from './GroupDetailContent';
import Card from '../components/Card';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import groupPath from '../utils/url/groupPath';

const GROUP_DETAIL_CARD_GROUP_FRAGMENT = gql(`
  fragment GroupDetailCard_group on Group {
    id
    ...GroupDetailContent_group
    ...groupPath_group
  }
`);

type GroupFragment = DocumentType<typeof GROUP_DETAIL_CARD_GROUP_FRAGMENT>;

const GROUP_DETAIL_CARD_PUBLIC_GROUP_FRAGMENT = gql(`
  fragment GroupDetailCard_publicGroup on GroupFields {
    id
    ...GroupDetailContent_publicGroup
    ...groupPath_group
  }
`);

type PublicGroupFragment = DocumentType<
  typeof GROUP_DETAIL_CARD_PUBLIC_GROUP_FRAGMENT
>;

interface GroupDetailCardProps {
  group: GroupFragment | PublicGroupFragment;
  numLines?: number;
}

const GroupDetailCard = ({ group, numLines }: GroupDetailCardProps) => {
  return (
    <Card noPadding to={groupPath(group)} ignoreInsideLinks>
      <GroupDetailContent group={group} numLines={numLines} />
    </Card>
  );
};

export default GroupDetailCard;
